<div class="confirm-your-cover">
  <h1 class="heading">Cover Confirmed!</h1>
  <div class="confirm-your-cover-content">
    <div *ngIf="coveredPolicyTypes" class="confirm-your-cover-whats-covered">
      <h3>What's covered</h3>
      <div class="separator"></div>
      <ul class="covered-list">
        <li *ngFor="let type of coveredPolicyTypes">
          <img src="/assets/icons/cover-confimed-covered.svg" />
          <p>{{ replacePolicyText(type.description) }}</p>
        </li>
      </ul>
    </div>
    <div
      *ngIf="notCoveredPolicyTypes"
      class="confirm-your-cover-whats-not-covered"
    >
      <h3>What's not covered</h3>
      <div class="separator"></div>
      <ul class="not-covered-list">
        <li *ngFor="let type of notCoveredPolicyTypes">
          <img src="/assets/icons/cover-confimed-not-covered.svg" />
          <p>{{ replacePolicyText(type.description) }}</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="confirm-your-cover-documents">
    <h2>Policy documents</h2>
    <div class="confirm-your-cover-document-buttons">
      <div class="spinner center" *ngIf="isLoading"></div>
      <a
        *ngIf="this.certificateUrl"
        [href]="this.certificateUrl"
        target="_blank"
        class="policy-cert"
        ><h5>Policy certificate</h5></a
      >
      <a
        *ngIf="this.keyWordingUrl"
        [href]="this.keyWordingUrl"
        target="_blank"
        class="key-facts"
        ><h5>Key facts</h5></a
      >
      <a
        *ngIf="this.policyWordingUrl"
        [href]="this.policyWordingUrl"
        target="_blank"
        class="policy-wording"
        ><h5>Policy wording</h5></a
      >
    </div>

    <div
      *ngIf="policyChangeYear"
      class="policy-year-change"
      [innerHTML]="policyYearChangeMessage.replace('{date}', policyChangeYear)"
    ></div>
  </div>
</div>
